export const viewAdminEnum = {
    PHOTOGRAPHERS: 'photographers',
    AGENCIES: 'agencies',
    MEDIA_USERS: 'media_users'
}
